import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Content,
  Header,
  Loader,
  Radio,
  InputGroup,
} from "rsuite";
import { Form, Field, FormSpy } from "react-final-form";
import { CommercialServices } from "../../../core/services/CommercialServices";
import "./Commercial.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { get, debounce, uniq, findIndex, findKey } from "lodash/fp";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { useSelector } from "react-redux";
import CustomSelector from "../../shared/customSelector";
import { useTranslation } from "react-i18next";
import useDecryptedParams from "../../../navigation/useDecryptParams";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { CommercialFields } from "./CommercialDataTypes";
import { useDispatch } from "react-redux";
import { setActionData } from "../../../redux/userActionData";
import CloseIcon from "@rsuite/icons/Close";
import SearchIcon from "@rsuite/icons/Search";
import {
  messageTypeArr,
  appConstObj,
  mediaTypeObjArr,
  mediaSourceObjArr,
  commercialNatureObjArr,
  roleTypeArr,
  commercialUseForObjArr,
} from "../../../core/config/AppConstants";
import { ValidatorCustom } from "../../validators/ValidatorCustom";
import { ContentRoutes } from "../../../navigation/NavConstant";
import { isNotEmpty, isNotNull } from "../../../utils/helpers";
import MediaFileUpload from "../../components/Elements/MediaFileUpload";
import ImageUpload from "../../components/Elements/ImageUpload";
import BrandsModal from "../Brands/BrandsModal";
import CampaignsModal from "../Campaigns/CampaignsModal";
function Commercial() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loader, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const company = useSelector((state: any) => state.company);
  const [commercialFetched, setCommercialFetched] = useState(false);

  const dispatch = useDispatch();
  const params: any = useParams();
  const [commercialImageFile, setCommercialImageFile] = useState<any>();
  const [commercialImage, setCommercialImage] = useState("");
  const [commercialPlayUrl, setCommercialPlayUrl] = useState<string>();
  const [commercialFile, setCommercialFile] = useState<any>(null);
  const [duration, setDuration] = useState<number>(0);

  const [commercialData, setCommercialData] = useState<CommercialFields>({});

  const [errorMessage, setErrorMessage] = useState("");
  const [openModalByName, setOpenModalByName] = useState("");
  let [decryptedParams] = useDecryptedParams(params);

  const ecryptedCmrcId = encryptUrl(`${decryptedParams.id}`);

  const [formData, setFormData] = useState<any>({
    name: "",
    file_name: null,
    media_image: null,
    brand_name: "",
    brand_id: null,
    campaign_name: "",
    campaign_id: null,
    media_type: "audio",
    media_nature: "",
    commercial_use_for: "",
    company_id: "",
    sourced_from: "form",
    status: 1,
  });

  const searchSelectEntity = (e: any, entity_name: string) => {
    if (getCompanyId() == null) {
      UtilityServices.showToaster({
        message: t("PLEASE_SELECT_FIELD", { field: t("COMPANY") }),
        type: messageTypeArr.error,
      });
      return false;
    }

    if (e.key === "Enter" || e.type === "click") {
      setOpenModalByName(entity_name);
    }
  };

  function getCompanyId() {
    let compId = null;
    if (UtilityServices.getLoggedInUser("user_type") === roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (company?.id) {
      compId = company.id;
    }
    return compId;
  }

  async function init() {
    try {
      if (decryptedParams.id) {
        setLoading(true);
        setCommercialFetched(false);
        const response: any = await CommercialServices.viewCommercial(
          +decryptedParams.id
        );
        const cmrcData: any = response?.data?.data;
        const keyMapper: any = { name: "title" };
        setCommercialData(cmrcData);
        let obj = { ...formData };
        //review comment: response?.data?.data? should be in a single variable and then used further upon;
        if (cmrcData?.media_image_url) {
          setCommercialImage(cmrcData?.media_image_url);
        }
        if (cmrcData?.media_file_url) {
          setCommercialPlayUrl(cmrcData?.media_file_url);
        }
        let keyMapperIndex = Object.keys(keyMapper);
        Object.keys(obj).map((formKey) => {
          if (keyMapperIndex.includes(formKey)) {
            obj[formKey] = cmrcData[keyMapper[formKey]];
          } else {
            obj[formKey] = cmrcData[formKey];
          }
        });
        setFormData({ ...obj });
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCommercialFetched(true); // Mark component as ready to render
    }
  }

  useEffect(() => {
    init();
  }, [decryptedParams.id]);

  useEffect(() => {}, []);

  async function saveCommercial(form: any, cmrcId?: any) {
    try {
      setLoading(true);
      setSubmitLoader(true);
      let response: any;
      if (cmrcId) {
        response = await CommercialServices.updateCommercial(+cmrcId, form);
      } else {
        response = await CommercialServices.createCommercial(form);
      }
      setCommercialData(response?.data?.data);
      setLoading(false);
      UtilityServices.showToaster({
        message: response?.data?.message,
      });
      navigate(ContentRoutes.COMMERCIALS);
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error?.message,
        type: messageTypeArr.error,
      });
      setErrorMessage(error?.message);
    } finally {
      setLoading(false);
      setSubmitLoader(false);
    }
  }

  const onSubmit = (val: any) => {
    if (submitLoader) {
      return;
    }

    const form = new FormData();
    const fileFieldNames = [
      "file_name",
      "media_image",
      "commercial_file",
      "image",
      "_commercial_file",
      "_image",
    ];
    for (var key in val) {
      if (isNotNull(val[key]) && !fileFieldNames.includes(key))
        form.append(key, val[key]);
    }
    let compId = getCompanyId();
    if (!decryptedParams.id && compId == null) {
      UtilityServices.showToaster({
        type: "warning",
        message: t("PLEASE_SELECT_FIELD", {
          field: t("COMPANY").toLowerCase(),
        }),
      });
      return;
    } else if (!decryptedParams.id) {
      form.set("company_id", compId);
    }
    if (commercialImageFile instanceof File && commercialImageFile.size > 0) {
      form.append("media_image", commercialImageFile, commercialImageFile.name);
    }
    if (commercialFile instanceof File && commercialFile.size > 0) {
      form.append("file_name", commercialFile, commercialFile.name);
    }
    if (decryptedParams.id) {
      form.delete("company_id");
      saveCommercial(form, decryptedParams.id);
    } else {
      saveCommercial(form);
    }
  };

  function onSelectBrand(brandData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{ brand_name: brandData?.brand_name, brand_id: brandData?.id },
    });
  }

  function onSelectCampaign(campaignData: any) {
    setOpenModalByName("");
    setFormData({
      ...formData,
      ...{
        campaign_name: campaignData?.campaign_name,
        campaign_id: campaignData?.id,
      },
    });
  }

  const handleFormValuesChange = (values) => {
    setFormData(values); // Update formData state with current form values
  };

  return (
    <div className="commercial">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Container className="container">
        <Header className="header">
          <h4 className="mb-3 commercial-page-title">
            {decryptedParams.id ? t("UPDATE") : t("CREATE")} {t("COMMERCIAL")}
          </h4>
        </Header>
        <Content className="content commercial-create-wrap">
          <Form
            onSubmit={onSubmit}
            validate={(values: any) => {
              const errors: any = {};
              if (!values.name) {
                errors.name = t("REQUIRED", {
                  field:
                    t("COMMERCIAL").toLowerCase() +
                    " " +
                    t("NAME").toLowerCase(),
                });
              }
              if (!(commercialFile instanceof File) && !decryptedParams.id) {
                errors.commercial_file = t("REQUIRED_SELECT", {
                  field:
                    t("COMMERCIAL").toLowerCase() +
                    " " +
                    t("FILE").toLowerCase(),
                });
              }

              if (!values.media_type) {
                errors.media_type = t("REQUIRED_SELECT", {
                  field:
                    t("MEDIA").toLowerCase() + " " + t("TYPE").toLowerCase(),
                });
              }

              if (!values.media_nature) {
                errors.media_nature = t("REQUIRED_SELECT", {
                  field:
                    t("COMMERCIAL").toLowerCase() +
                    " " +
                    t("TYPE").toLowerCase(),
                });
              }

              if (!values.commercial_use_for) {
                errors.commercial_use_for = t("REQUIRED_SELECT", {
                  field:
                    t("COMMERCIAL").toLowerCase() +
                    " " +
                    t("USE").toLowerCase() +
                    " " +
                    t("FOR").toLowerCase(),
                });
              }

              return errors;
            }}
            initialValues={{ ...formData }}
            render={({ handleSubmit, form, errors, submitFailed, values }) => (
              <form onSubmit={handleSubmit} className="commercial-form-shell">
                {commercialFetched && (
                  <div className="commercial-upload-grid">
                    <div className="commercial-upload-card">
                      <div className="commercial-section-subtitle">
                        Media File
                      </div>
                      <MediaFileUpload
                        name="_commercial_file"
                        accept="audio/*,video/mp4"
                        label="UPLOAD MEDIA FILE"
                        mediaFile={commercialFile}
                        setMediaFile={setCommercialFile}
                        mediaUrl={commercialPlayUrl}
                        mediaType={values?.media_type}
                        mediaImageUrl={commercialImage}
                        onMediaTypeChange={(selectedMediaType: string) => {
                          form.change("media_type", selectedMediaType);
                        }}
                        errorMessage={
                          submitFailed ? errors?.commercial_file : ""
                        }
                      />
                    </div>
                    <div className="commercial-upload-card">
                      <div className="commercial-section-subtitle">
                        Cover Image
                      </div>
                      <ImageUpload
                        name="_image"
                        entityImage={commercialImage}
                        setEntityImageFile={(v: File) => {
                          if (v && v.size) {
                            setCommercialImageFile(v);
                            setCommercialImage(URL.createObjectURL(v));
                          } else {
                            setCommercialImageFile(null);
                            setCommercialImage(null);
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
                <div className="form-part commercial-form-card">
                  <div className="commercial-section-heading">
                    Commercial Details
                  </div>
                  <div className="flex-container">
                    <Field
                      name="name"
                      validate={
                        ValidatorCustom.isAlphaNumericDashSpacePatternValidator
                      }
                    >
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label>
                            {t("COMMERCIAL")} {t("TITLE")}*
                          </label>
                          <input {...input} type="text" />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="media_nature">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("COMMERCIAL").toLocaleLowerCase() +
                                " " +
                                t("TYPE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="value"
                            labelKey="label"
                            isDisable={
                              !commercialNatureObjArr?.length ? true : false
                            }
                            labelName={t("COMMERCIAL") + " " + t("TYPE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("media_nature", "");
                            }}
                            listData={
                              commercialNatureObjArr?.length
                                ? commercialNatureObjArr
                                : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("media_nature", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="commercial_use_for">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("COMMERCIAL").toLocaleLowerCase() +
                                " " +
                                t("USE").toLocaleLowerCase() +
                                " " +
                                t("FOR").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="value"
                            labelKey="label"
                            isDisable={
                              !commercialUseForObjArr?.length ? true : false
                            }
                            labelName={
                              t("COMMERCIAL") + " " + t("USE") + " " + t("FOR")
                            }
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("commercial_use_for", "");
                            }}
                            listData={
                              commercialUseForObjArr?.length
                                ? commercialUseForObjArr
                                : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("commercial_use_for", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="media_type">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("MEDIA").toLocaleLowerCase() +
                                " " +
                                t("TYPE").toLocaleLowerCase(),
                            })}
                            isRequired={true}
                            valueKey="value"
                            labelKey="label"
                            isDisable={!mediaTypeObjArr?.length ? true : false}
                            labelName={t("MEDIA") + " " + t("TYPE")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("media_type", null);
                            }}
                            listData={
                              mediaTypeObjArr?.length ? mediaTypeObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("media_type", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  <div className="flex-container">
                    <Field name="brand_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-brand")
                            }
                          >
                            {t("SELECT") + " " + t("BRAND")}*
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              autoComplete="off"
                              disabled={true}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-brand")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-brand")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("brand_id", null);
                                form.change("brand_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="campaign_name">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label
                            onClick={(e: any) =>
                              searchSelectEntity(e, "select-campaign")
                            }
                          >
                            {t("SELECT") + " " + t("CAMPAIGN")}
                          </label>
                          <InputGroup>
                            <input
                              {...input}
                              type="text"
                              disabled={true}
                              autoComplete="off"
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-campaign")
                              }
                            />
                            <InputGroup.Button
                              title={t("SEARCH")}
                              onClick={(e: any) =>
                                searchSelectEntity(e, "select-campaign")
                              }
                            >
                              <SearchIcon />
                            </InputGroup.Button>
                            <InputGroup.Button
                              title={t("CLEAR")}
                              onClick={() => {
                                form.change("campaign_id", null);
                                form.change("campaign_name", "");
                              }}
                            >
                              <CloseIcon />
                            </InputGroup.Button>
                          </InputGroup>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="sourced_from">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <CustomSelector
                            loaderMsg={t("FETCHING_DATA_OF", {
                              field:
                                t("SOURCED").toLocaleLowerCase() +
                                " " +
                                t("FROM").toLocaleLowerCase(),
                            })}
                            isRequired={false}
                            valueKey="value"
                            labelKey="label"
                            isDisable={
                              !mediaSourceObjArr?.length ? true : false
                            }
                            labelName={t("SOURCED") + " " + t("FROM")}
                            defaultValue={input.value}
                            onClear={(event: any) => {
                              form.change("sourced_from", null);
                            }}
                            listData={
                              mediaSourceObjArr?.length ? mediaSourceObjArr : []
                            }
                            onSelect={(e: any, selectedObj: any) => {
                              form.change("sourced_from", e);
                            }}
                          />
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="status">
                      {({ input, meta }) => (
                        <div className="flex-item">
                          <label className="block">{t("STATUS")}*</label>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", 1);
                              }
                            }}
                            checked={input.value === 1 ? true : false}
                            name="status"
                            value="1"
                          >
                            {t("ACTIVE")}
                          </Radio>
                          <Radio
                            onChangeCapture={(e: any) => {
                              if (e.target.checked) {
                                form.change("status", 0);
                              }
                            }}
                            checked={input.value === 0 ? true : false}
                            name="status"
                            value="0"
                          >
                            {t("INACTIVE")}
                          </Radio>
                          {meta.error && meta.touched && (
                            <span>{meta.error}</span>
                          )}
                        </div>
                      )}
                    </Field>
                    <div className="flex-item"></div>
                  </div>
                </div>
                <div className="create-action d-flex flex-end commercial-create-actions">
                  <Link to={ContentRoutes.COMMERCIALS}>
                    <Button
                      appearance="primary"
                      color="blue"
                      type="button"
                      className="commercial-action-btn"
                    >
                      {t("BACK")} {t("TO").toLocaleLowerCase()}{" "}
                      {t("LIST").toLocaleLowerCase()}
                    </Button>
                  </Link>
                  <Button
                    appearance="primary"
                    color="green"
                    type="submit"
                    className="commercial-action-btn"
                    disabled={submitLoader}
                  >
                    {submitLoader ? (
                      <Loader size="sm" />
                    ) : decryptedParams.id ? (
                      t("UPDATE")
                    ) : (
                      t("CREATE")
                    )}
                  </Button>
                  <Button
                    appearance="default"
                    type="reset"
                    className="commercial-action-btn"
                    onClick={() => {
                      // review comment: move to new function
                      form.reset();
                      setCommercialImageFile("");
                      setCommercialImage("");
                      setCommercialPlayUrl("");
                      setCommercialFile("");
                    }}
                  >
                    {t("RESET")}
                  </Button>
                </div>
                <FormSpy
                  subscription={{ values: true }}
                  onChange={({ values }) => handleFormValuesChange(values)}
                />
              </form>
            )}
          />
          {openModalByName === "select-brand" && (
            <BrandsModal
              openModal={openModalByName === "select-brand" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectBrand={onSelectBrand}
              companyId={getCompanyId()}
            />
          )}

          {openModalByName === "select-campaign" && (
            <CampaignsModal
              openModal={openModalByName === "select-campaign" ? true : false}
              setOpenModal={setOpenModalByName}
              onSelectCampaign={onSelectCampaign}
              companyId={getCompanyId()}
            />
          )}
        </Content>
      </Container>
    </div>
  );
}

export default Commercial;
